import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbProps,
  Text,
  TextProps,
} from '@chakra-ui/react';
import ChevronRightIcon from '@sphere/icons/components/ChevronRight';
import { rem } from 'polished';
import { NavLink } from '../Link';

export type BreadcrumbsProps = BreadcrumbProps & {
  pages: {
    name: string;
    href: string;
  }[];
  activeColor?: string;
  textStyles?: TextProps;
};

export const Breadcrumbs = ({
  pages,
  activeColor,
  textStyles,
  ...breadcrumbProps
}: BreadcrumbsProps) => (
  <Breadcrumb
    data-testid="breadcrumbs"
    separator={<ChevronRightIcon boxSize={rem(10)} mb="space.4" />}
    spacing="space.12"
    sx={{ ol: { flexWrap: 'wrap' } }}
    {...breadcrumbProps}
  >
    {pages.map(({ href, name }, index, self) => {
      const isActive = index === self.length - 1;

      return (
        <BreadcrumbItem
          data-testid="breadcrumbs-item"
          key={index}
          isCurrentPage={isActive}
          pt="space.2"
        >
          <BreadcrumbLink
            // when NavLink is passed as prop to last element it renders as button for some reason, it should be a tag
            as={isActive ? 'a' : NavLink}
            href={isActive ? '' : href}
            tabIndex={isActive ? 0 : undefined}
            data-testid="breadcrumbs-item-link"
            cursor="unset"
            _hover={{
              textDecor: 'none',
            }}
          >
            <Text
              fontSize="sm"
              lineHeight="lg"
              fontWeight="normal"
              color={isActive ? activeColor || 'gray.6' : breadcrumbProps.color || 'white'}
              noOfLines={1}
              maxW={{ base: '14ch', md: 'unset' }}
              {...textStyles}
            >
              {name}
            </Text>
          </BreadcrumbLink>
        </BreadcrumbItem>
      );
    })}
  </Breadcrumb>
);
